module.exports = __webpack_public_path__ + "static/media/image-4.f349e82d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/depto-64/image-4.jpg
// module id = 265
// module chunks = 0